import styled, { css } from 'styled-components';

import { buttonStylePrimary as cssPrimaryButtonStyle } from '~/src/common/components/Button/Variants/PrimaryButton';
import { buttonStyleSecondary as cssSecondaryButtonStyle } from '~/src/common/components/Button/Variants/SecondaryButton';
import { COLORS } from '~/src/common/theme';

const cssTertiaryButtonStyle = css`
  color: ${COLORS.NEUTRAL_WHITE};
  background: ${COLORS.ACTION_DEFAULT};
  border-color: ${COLORS.ACTION_DEFAULT};

  & a {
    border-color: ${COLORS.ACTION_DEFAULT};
  }

  &:hover,
  &:active {
    border-color: ${COLORS.ACTION_DEFAULT};
    background: ${COLORS.ACTION_HOVER};
    color: ${COLORS.NEUTRAL_WHITE};
  }
`;

export const StyledLink = styled.a<{ variant: 'primary' | 'secondary' | 'tertiary' }>`
  ${({ variant }) =>
    variant === 'primary'
      ? cssPrimaryButtonStyle
      : variant === 'secondary'
      ? cssSecondaryButtonStyle
      : cssTertiaryButtonStyle}

  padding: 8px 24px;

  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  text-align: center;
  border-radius: 4px;
  border: 1.6px solid ${COLORS.ACTION_DEFAULT};
  box-shadow: none;
`;
